import React from "react";
import { createContext, useContext, useReducer } from "react";

/**
 * React Context and Provider setup
 */
const StateContext = createContext();
const StateProvider = ({ reducer, initialState, children }) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>{children}</StateContext.Provider>
);
const useGlobalValue = () => useContext(StateContext);

/**
 * Initial State
 */
const initialState = {
  isLoading: false,
  errors: [],
  refresh: false,
  isLoggedIn: false,
  sysCfg: localStorage.getItem("sysCfg") ? JSON.parse(localStorage.getItem("sysCfg")) : {},
  service: localStorage.getItem("service") ? JSON.parse(localStorage.getItem("service")) : {},
  user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
};

/**
 * App Reducer
 */
const reducer = (state, action) => {
  switch (action.type) {
    case "setIsLoading":
      return {
        ...state,
        isLoading: action.isLoading
      };
    case "setErrors":
      return {
        ...state,
        errors: action.errors
      };
    case "setRefresh":
      return {
        ...state,
        refresh: action.refresh
      };
    case "setIsLoggedIn":
      return {
        ...state,
        isLoggedIn: action.isLoggedIn
      };
    case "setSysCfg":
      localStorage.setItem("sysCfg", JSON.stringify(action.sysCfg));
      return {
        ...state,
        sysCfg: action.sysCfg
      };
    case "setService":
      localStorage.setItem("service", JSON.stringify(action.service));
      return {
        ...state,
        service: action.service
      };
    case "setUser":
      localStorage.setItem("user", JSON.stringify(action.user));
      return {
        ...state,
        user: action.user
      };
    default:
      return state;
  }
};

export { StateProvider, useGlobalValue, reducer, initialState };
